import React, { useState, useEffect } from 'react';
import t from '../../../utils/t';

const CategoryDrawerAccordionItem = (props) => {
  const { translation, icon, children, handleCategorySelect } = props;
  const [active, setActive] = useState(false);
  const haveSubCategory = children && children.length > 0;

  const toggle = () => setActive(!active);

  if (!translation) return null;

  return(
    <div className="categories-accordion__item">
      <header className="categories-accordion__item__header">
        <img loading="lazy" className="categories-accordion__item__icon" onClick={() => handleCategorySelect('main', props)} src={icon ? icon : '/images/logo-circle.svg'} />
        <h3 className="categories-accordion__item__title" onClick={() => handleCategorySelect('main', props)}>{translation && translation.title}</h3>
        {haveSubCategory && <a className={`categories-accordion__item__toggler ${active ? 'is-active' : ''}`} onClick={toggle} />}
      </header>
      <div className={`categories-accordion__item__inner ${active ? 'is-active' : ''}`}>
        <ul>
          {haveSubCategory && children.map(subCategory => (
            <li key={subCategory.id}><a onClick={() => handleCategorySelect('sub', subCategory)}>{subCategory.translation && subCategory.translation.title}</a></li>
          ))}
        </ul>
      </div>
    </div>
  )
};

const CategoriesDrawer = (props) => {
  const {
    open,
    setOpen,
    setActiveCategory,
    setActiveSubCategory,
    categories,
    voucher,
    setVoucher,
    giftCard,
    setGiftCard,
    taxFree,
    setTaxFree,
  } = props;

  useEffect(() => {
    if (!voucher && window.options.filters.voucher) {
      window.location.href = window.location.href.split('/').reverse().splice(1).reverse().join('/');
    }
  }, [voucher]);

  useEffect(() => {
    if (!giftCard && window.options.filters.giftCard) {
      window.location.href = window.location.href.split('/').reverse().splice(1).reverse().join('/');
    }
  }, [giftCard]);

  useEffect(() => {
    if (!taxFree && window.options.filters.tax_free) {
      window.location.href = window.location.href.split('/').reverse().splice(1).reverse().join('/');
    }
  }, [taxFree]);

  function handleCategorySelect(type, category) {
    if (type === 'main') {
      setOpen(false);
      setActiveSubCategory(null);
      return setActiveCategory(category)
    }

    setOpen(false);
    setActiveSubCategory(category);
  }

  return(
    <div className={`categories-drawer ${open ? 'is-active' : ''}`}>
      <div className="container column">
        <div className="columns is-centered">
          <div className="column is-8">
            <a className="categories-drawer__back" onClick={() => setOpen(false)}>
              {t('stores.search.back-to-list')}
            </a>
            <div className="categories-drawer__tags columns">
              <div className="column">
                <a className={`tag ${taxFree ? 'is-active' : ''}`} onClick={() => {
                  setTaxFree(!taxFree);
                  setOpen(false);
                }}>
                  <span className="icomoon-tax-free" />
                  {t('stores.attributes.tax_free')}
                </a>
              </div>
              {<div className="column">
                <a className={`tag ${voucher ? 'is-active' : ''}`} onClick={() => {
                  setVoucher(!voucher);
                  setOpen(false);
                }}>
                  <span className="icomoon-voucher" />
                  {t('stores.attributes.voucher')}
                </a>
              </div>}
              {<div className="column">
                <a className={`tag ${giftCard ? 'is-active' : ''}`} onClick={() => {
                  setGiftCard(!giftCard);
                  setOpen(false);
                }}>
                  <span className="icomoon-gift-card-new" />
                  {t('stores.attributes.gift_card')}
                </a>
              </div>}
            </div>
            <div className="categories-accordion">
              {categories.map(category => <CategoryDrawerAccordionItem key={category.id} {...category} handleCategorySelect={handleCategorySelect} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default CategoriesDrawer;



// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-search/components/CategoriesDrawer.jsx